const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNovaGroup2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#fc0",
      fillOpacity: 1,
      fillRule: "nonzero",
      strokeWidth: 13.345
    },
    d: "M0 208.847h744.094v984.83H0Z",
    transform: "matrix(.09139 0 0 .09139 0 16.914)"
  }), /*#__PURE__*/React.createElement("g", {
    "aria-label": "NOVA",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontSize: "267.972px",
      lineHeight: "0%",
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway Ultra-Bold'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#7d7d7d",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "22.331px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.238 28.895V137.69H9.291v-190.26h34.3L132.29 59.176V-52.57h43.947v190.26h-35.372zM296.226 139.3q-21.17 0-38.588-8.308-17.418-8.307-29.745-21.706-12.327-13.666-19.294-31.084-6.7-17.419-6.7-35.909 0-18.758 6.968-36.176 7.235-17.418 19.83-30.549 12.863-13.398 30.28-21.17 17.419-8.039 38.053-8.039 21.17 0 38.588 8.308 17.418 8.307 29.745 21.973 12.326 13.667 19.026 31.085 6.699 17.418 6.699 35.372 0 18.758-7.235 36.177-6.968 17.418-19.562 30.816-12.595 13.13-30.013 21.17-17.418 8.04-38.052 8.04zM246.65 42.83q0 10.986 3.216 21.437 3.215 10.183 9.379 18.222 6.431 8.04 15.81 12.863 9.38 4.823 21.438 4.823 12.594 0 21.973-5.091 9.38-5.092 15.543-13.13 6.163-8.308 9.11-18.49 3.217-10.452 3.217-21.17 0-10.987-3.216-21.17-3.216-10.451-9.647-18.222-6.431-8.04-15.81-12.595-9.111-4.824-21.17-4.824-12.595 0-21.974 5.092-9.111 4.823-15.542 12.862-6.164 8.04-9.38 18.49-2.947 10.183-2.947 20.902zM437.28-52.569 482.03 82.49l44.216-135.058h46.36l-72.085 190.26h-36.98l-72.889-190.26ZM625.74-52.569h39.66l69.404 190.26h-45.02l-14.738-42.607h-59.222l-14.47 42.607h-45.02Zm42.07 117.372-22.24-67.26-22.778 67.26Z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 800,
      fontStretch: "normal",
      fontFamily: "Raleway",
      InkscapeFontSpecification: "'Raleway Ultra-Bold'",
      fill: "#7d7d7d",
      fillOpacity: 1,
      strokeWidth: "22.331px"
    },
    transform: "matrix(.09139 0 0 .09139 0 16.914)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "829.604px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 20.7401
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M601.96 997.376H187.97v-87.093L336.633 760q66.028-67.649 86.282-93.574 20.254-26.33 29.166-48.61 8.912-22.279 8.912-46.178 0-35.647-19.85-53.066-19.443-17.418-52.254-17.418-34.432 0-66.839 15.798-32.406 15.798-67.648 44.964l-68.053-80.611q43.748-37.268 72.509-52.66 28.76-15.394 62.787-23.495 34.027-8.507 76.155-8.507 55.496 0 98.03 20.254 42.533 20.254 66.028 56.711 23.494 36.457 23.494 83.447 0 40.913-14.583 76.965-14.177 35.647-44.558 73.32-29.976 37.672-106.131 107.346l-76.155 71.699v5.67H601.96z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontFamily: "'Open Sans'",
      InkscapeFontSpecification: "'Open Sans Bold'",
      fill: "#fff",
      strokeWidth: 20.7401
    },
    transform: "matrix(.09139 0 0 .09139 0 16.914)",
    "aria-label": 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovaGroup2);
export default __webpack_public_path__ + "static/media/nova-group-2.1308fdb0753bead04d95855c5e28f079.svg";
export { ForwardRef as ReactComponent };